import { render, staticRenderFns } from "./ConvenioSetting.vue?vue&type=template&id=656582c7"
import script from "./ConvenioSetting.vue?vue&type=script&lang=js"
export * from "./ConvenioSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports